<!--
作業記録
URL：worklog
-->

<template>
  <div>
    <v-container style="max-width: 800px">
      <p class="text-center text-h3">作業記録</p>
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">作業日</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <custom-date-picker
                  :events="events"
                  :date-sub="dateSub"
                  :defaultFocus="dateSub"
                  @on-update-registration-date="updateRegistrationDate"
                  @on-update-calendar-month="updateCalendarEvent"
              ></custom-date-picker>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">採苗の管理</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="通し替え"
                  color="#0ddbc7"
                  v-model="formData.seedling_replacement"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="採苗器作成"
                  color="#0ddbc7"
                  v-model="formData.seedling_collector_create"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="採苗"
                  color="#0ddbc7"
                  v-model="formData.seedling_perform"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="種場移動"
                  color="#0ddbc7"
                  v-model="formData.seedling_seed_field_move"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-card-text>
              <v-card-subtitle class="custom-card-subtitle">採苗枚数</v-card-subtitle>
              <v-row align="center">
                <v-col cols="auto"></v-col>
                <v-col cols="3">
                  <v-text-field
                      :width="12"
                      color="#0ddbc7"
                      maxlength="8"
                      regular
                      hide-details="auto"
                      dense
                      class="text-h6 text-align:center"
                      v-model.number="$v.formData.seedling_quantity.$model"
                      :error-messages="seedlingQuantityErrorMessage"
                      @change="seedlingQuantityMin"
                      :disabled="!formData.seedling_perform"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-card-text class="custom-card-text"> 枚 </v-card-text>
                </v-col>
              </v-row>
              <v-col cols="auto">
              </v-col>
            </v-card-text>
          </v-row>

          <v-row v-for="item in seedling_others" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('SEEDLING', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editSeedling(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteSeedling(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendSeedling">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">筏の管理</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="筏移動"
                  color="#0ddbc7"
                  v-model="formData.raft_move"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="空筏移動"
                  color="#0ddbc7"
                  v-model="formData.raft_move_of_empty"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="吊り手上げ"
                  color="#0ddbc7"
                  v-model="formData.raft_strap_lift"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="筏修理"
                  color="#0ddbc7"
                  v-model="formData.raft_strap_repair"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="筏解体"
                  color="#0ddbc7"
                  v-model="formData.raft_dismantling"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row v-for="item in raft_others" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('RAFT', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editRaft(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteRaft(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendRaft">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">船の管理</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="船底掃除"
                  color="#0ddbc7"
                  v-model="formData.ship_seabed_cleaning"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="船修繕"
                  color="#0ddbc7"
                  v-model="formData.ship_repair"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="エンジン修繕"
                  color="#0ddbc7"
                  v-model="formData.ship_engine_repair"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row v-for="item in ship_others" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('SHIP', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editShip(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteShip(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendShip">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">作業場の管理</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="機械の整備"
                  color="#0ddbc7"
                  v-model="formData.workplace_facility_repair"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="修理"
                  color="#0ddbc7"
                  v-model="formData.workplace_repair"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row v-for="item in workplace_others" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('WORKPLACE', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editWorkplace(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteWorkplace(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendWorkplace">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">資材の管理</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="資材購入"
                  color="#0ddbc7"
                  v-model="formData.material_purchase"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  label="資材運搬"
                  color="#0ddbc7"
                  v-model="formData.material_transportation"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
            </v-col>
          </v-row>

          <v-row v-for="item in material_others" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('MATERIAL', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editMaterial(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteMaterial(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendMaterial">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">その他の作業</v-card-title>
        <v-card-text>
          <v-row v-for="item in other_works" :key="item.id">
            <v-col cols="auto" class="mr-auto">
              <v-checkbox
                  class="big-checkbox"
                  :label="item.label"
                  :value="item.checked"
                  :input-value="item.checked"
                  @change="onChange('OTHER', item.id);"
                  color="#0ddbc7"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-btn @click="editOther(item.id, item.label)">
                編集
              </v-btn>
              <v-btn @click="deleteOther(item.id, item.label)">
                削除
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col align="center">
              <v-btn slot="append" icon outlined color="primary" @click="appendOther">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">本日の作業詳細</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                  solo
                  label="(気づきとか作業内容を記載ください)"
                  v-model="formData.today_work_details"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
              color="secondary"
              outlined
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="cancel"
          >やめる
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              color="primary"
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="inputCheck"
          >保存
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h4">{{ dialog_title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      placeholder="その他（５文字程度）"
                      required
                      v-model="dialog_name"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="secondary"
                outlined
                style="font-size: 24px"
                class="ma-2"
                width="200"
                height="50"
                @click="dialog = false"
            >やめる
            </v-btn>
            <v-btn
                color="primary"
                style="font-size: 24px"
                class="ma-2"
                width="200"
                height="50"
                @click="saveDialog"
            >保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
          v-model="dialog_delete"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h4">{{ dialog_title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="text-h5">
                  {{ dialog_name }} を削除しますか？
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="secondary"
                outlined
                style="font-size: 24px"
                class="ma-2"
                width="200"
                height="50"
                @click="dialog_delete = false"
            >やめる
            </v-btn>
            <v-btn
                color="primary"
                style="font-size: 24px"
                class="ma-2"
                width="200"
                height="50"
                @click="deleteDialog"
            >削除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import CustomDatePicker from "../components/record-update/custom-date-picker.vue";
import Api from "@/logic/api/api.js";
import DateWrapper from "../logic/common/date-wrapper";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import valueMapper from "../logic/common/value-mapper";
import Validate from "@/logic/common/validate";

export default {
  components: {
    "custom-date-picker": CustomDatePicker,
    alert: Alert,
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 採苗枚数
      seedling_quantity: {
        singleByteNumber: Validate.rule.singleByteNumber,
      },
    },
  },
  data() {
    return {
      id: '',
      mode: 'create',
      dateSub: '',

      dialog: false,
      dialog_delete: false,

      dialog_id: 0,
      dialog_title: '',
      dialog_type: '',
      dialog_name: '',
      dialog_error: false,

      events: {},
      menu: "",
      errors: [],
      date_api: 0,

      seedling_others: [],
      raft_others: [],
      ship_others: [],
      workplace_others: [],
      material_others: [],
      other_works: [],

      formData: {
        seedling_replacement: false,
        seedling_collector_create: false,
        seedling_perform: false,
        seedling_seed_field_move: false,
        seedling_quantity: "",
        seedling_others: [],

        raft_move: false,
        raft_move_of_empty: false,
        raft_strap_lift: false,
        raft_strap_repair: false,
        raft_dismantling: false,
        raft_others: [],

        ship_seabed_cleaning: false,
        ship_repair: false,
        ship_engine_repair: false,
        ship_others: [],

        workplace_facility_repair: false,
        workplace_repair: false,
        workplace_others: [],

        material_purchase: false,
        material_transportation: false,
        material_others: [],

        other_works: [],

        today_work_details: "",
      },
    };
  },
  mounted() {
    let today = new Date();
    let year = today.getFullYear();
    let month = ("0" + (today.getMonth() + 1)).slice(-2);
    let date = ("0" + today.getDate()).slice(-2);
    // api登録用形式の日付
    this.date_api = year + "/" + month + "/" + date;

    if (this.$route.params.id && this.$route.params.mode) {
      if (this.$route.params.mode !== 'edit' && this.$route.params.mode !== 'copy') {
        this.$router.push("/error");
        return;
      }

      this.id = this.$route.params.id;
      this.mode = this.$route.params.mode;
      this.getWorklog();
    } else {
      this.getSeedling();
      this.getRaft();
      this.getShip();
      this.getWorkplace();
      this.getMaterial();
      this.getOther();
    }
  },
  computed: {
    /**
     * エラーメッセージ：採苗枚数
     */
    seedlingQuantityErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
          this.$v.formData.seedling_quantity,
          "採苗枚数",
          ["singleByteNumber"]
      );
    },
  },
  methods: {
    /**
     * 登録日を更新する
     */
    updateRegistrationDate(registrationDate) {
      // API指定用登録日
      this.date_api = registrationDate.replace(/-/g, "/");
    },

    /**
     * カレンダーの月間イベント更新
     */
    updateCalendarEvent(registrationDate) {
      this.applyDataToMonthlyArea(registrationDate);
    },

    /**
     * カレンダー表示用月間イベント取得処理
     */
    applyDataToMonthlyArea(date) {
      const {apiList, mapping} = this.haccpInfoRequest({
        date: new DateWrapper(date),
        daily: false,
        requireUserInfo: false,
      });

      this.$nextTick(() => {
        // APIのリクエスト
        this.$store.commit("setWaiting", true);
        Promise.all(apiList)
            .then((result) => {
              this.$store.commit("setWaiting", false);
              this.events = {
                unloading: result[mapping.unloading].record_list.map(
                    (item) => new DateWrapper(item.record_date).format.systemDate
                ),
                shipping: result[mapping.shipping].record_list.map(
                    (item) => new DateWrapper(item.record_date).format.systemDate
                ),
                seawater: result[mapping.seawater].record_list.map(
                    (item) => new DateWrapper(item.record_date).format.systemDate
                ),
                worklog: result[mapping.worklog].record_list.map(
                    (item) => new DateWrapper(item.record_date).format.systemDate
                ),
              };
            })
            .catch((error) => {
              this.$store.commit("setWaiting", false);
              if (error.status == 403) {
                this.errors.push(AlertBuilder.error("権限がありません"));
              } else {
                Api.resolve(error);
              }
            });
      });
    },

    haccpInfoRequest(parameter) {
      const date = parameter["date"] || new DateWrapper(Date.now());
      const daily = parameter["daily"] || false;
      const requireUserInfo = parameter["requireUserInfo"] || false;

      let requestDate = {
        year: date.format.build((d) => new String(d.date.y)),
        month: date.format.build((d) => new String(d.date.m02)),
      };
      if (daily) {
        requestDate["day"] = date.format.build((d) => new String(d.date.d02));
      }
      var apiList = [];
      var keys = [];
      if (requireUserInfo) {
        keys.push("user");
        apiList.push(
            Api.call("/admin/user", {
              purpose: "VIEW_HACCP",
            })
        );
      }

      keys.push(...["worklog", "shipping", "unloading", "seawater"]);
      apiList.push(
          ...[
            Api.call("/work/record", {
              uid: this.$store.getters.userId,
              record_type: "WORKLOG",
              record_date: requestDate,
            }),
            Api.call("/haccp/record", {
              uid: this.$store.getters.userId,
              record_type: "SHIPPING",
              record_date: requestDate,
            }),
            Api.call("/haccp/record", {
              uid: this.$store.getters.userId,
              record_type: "UNLOADING",
              record_date: requestDate,
            }),
            Api.call("/haccp/record", {
              uid: this.$store.getters.userId,
              record_type: "SEAWATER",
              record_date: requestDate,
            }),
          ]
      );
      return {
        apiList: apiList,
        mapping: keys.reduce((map, key, index) => {
          map[key] = index;
          return map;
        }, {}),
      };
    },

    getDateString() {
      let d = new Date();
      let year = d.getFullYear();
      let month = d.getMonth() + 1;
      let day = d.getDate();
      let hours = d.getHours();
      let minutes = d.getMinutes();
      let seconds = d.getSeconds();
      return year + "/" +
          ("0" + month).slice(-2) + "/" +
          ("0" + day).slice(-2) + " " +
          ("0" + hours).slice(-2) + ":" +
          ("0" + minutes).slice(-2) + ":" +
          ("0" + seconds).slice(-2);
    },

    getWorklog() {
      if (this.id) {
        let date = new DateWrapper(Date.now());

        let requestDate = {
          year: date.format.build((d) => new String(d.date.y)),
          month: date.format.build((d) => new String(d.date.m02)),
          day: date.format.build((d) => new String(d.date.d02)),
        };

        let body = {
          record_type: "WORKLOG",
          record_date: requestDate,
          record_id: parseInt(this.id),
        };

        if (this.$store.getters.userId) {
          body['uid'] = this.$store.getters.userId;
        }

        Api.call("/work/record", body)
            .then((response) => {
              if (response.record_list[0].body) {
                this.formData = response.record_list[0].body;
                if (this.mode === 'edit') {
                  this.dateSub = response.record_list[0].record_date;
                  this.date_api = response.record_list[0].record_date;
                }
                this.getSeedling();
                this.getRaft();
                this.getShip();
                this.getWorkplace();
                this.getMaterial();
                this.getOther();
              }
            })
            .catch((error) => {
              Api.resolve(error);
            });
      }
    },

    // SEEDLING
    getSeedling() {
      this.getInputHistory('SEEDLING');
    },

    appendSeedling() {
      this.dialog_title = '採苗の管理の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'SEEDLING';
      this.dialog = true;
    },

    editSeedling(id, label) {
      this.dialog_title = '採苗の管理の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'SEEDLING';
      this.dialog = true;
    },

    deleteSeedling(id, label) {
      this.dialog_title = '採苗の管理の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'SEEDLING';
      this.dialog_delete = true;
    },

    // RAFT
    getRaft() {
      this.getInputHistory('RAFT');
    },

    appendRaft() {
      this.dialog_title = '筏の管理の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'RAFT';
      this.dialog = true;
    },

    editRaft(id, label) {
      this.dialog_title = '筏の管理の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'RAFT';
      this.dialog = true;
    },

    deleteRaft(id, label) {
      this.dialog_title = '筏の管理の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'RAFT';
      this.dialog_delete = true;
    },

    // SHIP
    getShip() {
      this.getInputHistory('SHIP');
    },

    appendShip() {
      this.dialog_title = '船の管理の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'SHIP';
      this.dialog = true;
    },

    editShip(id, label) {
      this.dialog_title = '船の管理の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'SHIP';
      this.dialog = true;
    },

    deleteShip(id, label) {
      this.dialog_title = '船の管理の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'SHIP';
      this.dialog_delete = true;
    },

    // WORKPLACE
    getWorkplace() {
      this.getInputHistory('WORKPLACE');
    },

    appendWorkplace() {
      this.dialog_title = '作業場の管理の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'WORKPLACE';
      this.dialog = true;
    },

    editWorkplace(id, label) {
      this.dialog_title = '作業場の管理の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'WORKPLACE';
      this.dialog = true;
    },

    deleteWorkplace(id, label) {
      this.dialog_title = '作業場の管理の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'WORKPLACE';
      this.dialog_delete = true;
    },

    // MATERIAL
    getMaterial() {
      this.getInputHistory('MATERIAL');
    },

    appendMaterial() {
      this.dialog_title = '資材の管理の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'MATERIAL';
      this.dialog = true;
    },

    editMaterial(id, label) {
      this.dialog_title = '資材の管理の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'MATERIAL';
      this.dialog = true;
    },

    deleteMaterial(id, label) {
      this.dialog_title = '資材の管理の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'MATERIAL';
      this.dialog_delete = true;
    },

    // OTHER
    getOther() {
      this.getInputHistory('OTHER');
    },

    appendOther() {
      this.dialog_title = 'その他の作業の項目追加';
      this.dialog_id = '';
      this.dialog_name = '';
      this.dialog_type = 'OTHER';
      this.dialog = true;
    },

    editOther(id, label) {
      this.dialog_title = 'その他の作業の項目編集';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'OTHER';
      this.dialog = true;
    },

    deleteOther(id, label) {
      this.dialog_title = 'その他の作業の項目削除';
      this.dialog_id = id;
      this.dialog_name = label;
      this.dialog_type = 'OTHER';
      this.dialog_delete = true;
    },

    saveDialog() {
      if (this.dialog_name !== '') {
        this.dialog = false;
        this.updateInputHistory();
      } else {
        this.dialog_error = true;
      }
    },

    deleteDialog() {
      if (this.dialog_id) {
        this.deleteInputHistory();
      }
      this.dialog_delete = false;
    },

    onChange(type, id) {
      if (type === 'SEEDLING') {
        this.handleOthersCheckbox(id, this.seedling_others, this.formData.seedling_others);
      } else if (type === 'RAFT') {
        this.handleOthersCheckbox(id, this.raft_others, this.formData.raft_others);
      } else if (type === 'SHIP') {
        this.handleOthersCheckbox(id, this.ship_others, this.formData.ship_others);
      } else if (type === 'WORKPLACE') {
        this.handleOthersCheckbox(id, this.workplace_others, this.formData.workplace_others);
      } else if (type === 'MATERIAL') {
        this.handleOthersCheckbox(id, this.material_others, this.formData.material_others);
      } else if (type === 'OTHER') {
        this.handleOthersCheckbox(id, this.other_works, this.formData.other_works);
      }
    },

    handleOthersCheckbox(id, data, formData) {
      data.some((value, index) => {
        if (value.id === id) {
          if (value.checked) {
            // true ⇒ false のため、データを削除する
            formData.some((value2, index2) => {
              if (value2 === value.label) {
                formData.splice(index2, 1);
                return true;
              }
            });
          } else {
            // false ⇒ true のため、データを追加する
            formData.push(value.label);
          }

          this.$set(data, index, {'id': id, 'label': value.label, 'checked': !value.checked});
          return true;
        }
      });
    },

    appendCheckboxData(id, label, data) {
      data.push({'id': id, 'label': label, 'checked': false});
    },

    updateCheckboxData(id, label, data, formData) {
      data.some((value, index) => {
        if (value.id === id) {
          if (value.checked) {
            formData.some((value2, index2) => {
              if (value2 === value.label) {
                formData[index2] = label;
                return true;
              }
            });
          }
          this.$set(data, index, {id: id, label: label, checked: data[index].checked});
          return true;
        }
      });
    },

    deleteCheckboxData(id, data, formData) {
      data.some((value, index) => {
        if (value.id === id) {
          if (value.checked) {
            formData.some((value2, index2) => {
              if (value2 === value.label) {
                formData.splice(index2, 1);
                return true;
              }
            });
          }

          data.splice(index, 1);
          return true;
        }
      });
    },

    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },

    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },

    /**
     * 格納データを作成する
     */
    buildbodyBodyData() {
      return {
        type: "WORKLOG",
        worklog_date: this.date_api,
        ...this.formData,
      };
    },

    /**
     * 登録用送信データを画面から取得する
     */
    buildRegisterData() {
      let body = {
        record_type: "WORKLOG",
        record_date: this.date_api,
        body: this.buildbodyBodyData(),
      };

      if (this.id && this.mode === 'edit') {
        body['record_id'] = parseInt(this.id);
      }

      return body;
    },

    /**
     * 更新用登録データを画面から取得する
     */
    buildUpdateData() {
    },

    /**
     * 水揚げ量・連数最小値設定(0以上)
     */
    seedlingQuantityMin() {
      if (this.formData.seedling_quantity < 0) {
        this.formData.seedling_quantity = 0;
      }
    },

    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
        // 採苗枚数が空白であるかをチェック
      if (this.formData.seedling_quantity === "") {
        // 空白の場合、-1に置き換える
        this.formData.seedling_quantity = -1;
      }

      this.clearMessage();
      this.register();
    },

    getInputHistory(type) {
      var that = this;
      let updateUrl = "/work/history";

      // category
      // SEEDLING
      // RAFT
      // SHIP
      // WORKPLACE
      // MATERIAL
      // OTHER
      let postData = {
        'record_type': 'WORKLOG',
        'category': type,
      }

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then((response) => {
            let id = -1;
            if (type === 'SEEDLING') {

              // ページの表示前にチェックを行う
              if (this.formData.seedling_quantity === -1) {
                // -1の場合、空白に置き換える
                this.formData.seedling_quantity = "";
              }

              that.seedling_others = [];
              let noIdOthers = that.formData.seedling_others.concat();

              response.record_list.forEach((value) => {
                that.seedling_others.push({id: value.record_id, label: value.display_name, checked: that.formData.seedling_others.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.seedling_others.push({id: id, label: value, checked: true});
                id--;
              });
            } else if (type === 'RAFT') {
              that.raft_others = [];
              let noIdOthers = that.formData.raft_others.concat();

              response.record_list.forEach((value) => {
                that.raft_others.push({id: value.record_id, label: value.display_name, checked: that.formData.raft_others.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.raft_others.push({id: id, label: value, checked: true});
                id--;
              });
            } else if (type === 'SHIP') {
              that.ship_others = [];
              let noIdOthers = that.formData.ship_others.concat();

              response.record_list.forEach((value) => {
                that.ship_others.push({id: value.record_id, label: value.display_name, checked: that.formData.ship_others.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.ship_others.push({id: id, label: value, checked: true});
                id--;
              });
            } else if (type === 'WORKPLACE') {
              that.workplace_others = [];
              let noIdOthers = that.formData.workplace_others.concat();

              response.record_list.forEach((value) => {
                that.workplace_others.push({id: value.record_id, label: value.display_name, checked: that.formData.workplace_others.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.workplace_others.push({id: id, label: value, checked: true});
                id--;
              });
            } else if (type === 'MATERIAL') {
              that.material_others = [];
              let noIdOthers = that.formData.material_others.concat();

              response.record_list.forEach((value) => {
                that.material_others.push({id: value.record_id, label: value.display_name, checked: that.formData.material_others.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.material_others.push({id: id, label: value, checked: true});
                id--;
              });
            } else if (type === 'OTHER') {
              that.other_works = [];
              let noIdOthers = that.formData.other_works.concat();

              response.record_list.forEach((value) => {
                that.other_works.push({id: value.record_id, label: value.display_name, checked: that.formData.other_works.includes(value.display_name)});
                let index = noIdOthers.indexOf(value.display_name);
                if (index >= 0) {
                  noIdOthers.splice(index, 1);
                }
              });

              noIdOthers.forEach((value) => {
                that.other_works.push({id: id, label: value, checked: true});
                id--;
              });
            }
            this.$store.commit("setWaiting", false);
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },

    updateInputHistory() {
      var that = this;
      let updateUrl = "/work/history/update";

      // category
      // SEEDLING
      // RAFT
      // SHIP
      // WORKPLACE
      // MATERIAL
      // OTHER
      let postData = {
        'record_type': 'WORKLOG',
        'category': this.dialog_type,
        'display_name': this.dialog_name,
        'update_date': this.getDateString(),
      }

      if (this.dialog_id < 0) {
        if (this.dialog_type === 'SEEDLING') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.seedling_others, this.formData.seedling_others)
        } else if (this.dialog_type === 'RAFT') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.raft_others, this.formData.raft_others)
        } else if (this.dialog_type === 'SHIP') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.ship_others, this.formData.ship_others)
        } else if (this.dialog_type === 'WORKPLACE') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.workplace_others, this.formData.workplace_others)
        } else if (this.dialog_type === 'MATERIAL') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.material_others, this.formData.material_others)
        } else if (this.dialog_type === 'OTHER') {
          this.updateCheckboxData(this.dialog_id, this.dialog_name, this.other_works, this.formData.other_works)
        }
        return;
      }

      if (this.dialog_id) {
        postData['record_id'] = this.dialog_id;
      }

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then((response) => {
            if (that.dialog_id) {
              if (this.dialog_type === 'SEEDLING') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.seedling_others, that.formData.seedling_others)
              } else if (this.dialog_type === 'RAFT') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.raft_others, that.formData.raft_others)
              } else if (this.dialog_type === 'SHIP') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.ship_others, that.formData.ship_others)
              } else if (this.dialog_type === 'WORKPLACE') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.workplace_others, that.formData.workplace_others)
              } else if (this.dialog_type === 'MATERIAL') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.material_others, that.formData.material_others)
              } else if (this.dialog_type === 'OTHER') {
                this.updateCheckboxData(that.dialog_id, that.dialog_name, that.other_works, that.formData.other_works)
              }
            } else {
              if (this.dialog_type === 'SEEDLING') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.seedling_others);
              } else if (this.dialog_type === 'RAFT') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.raft_others);
              } else if (this.dialog_type === 'SHIP') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.ship_others);
              } else if (this.dialog_type === 'WORKPLACE') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.workplace_others);
              } else if (this.dialog_type === 'MATERIAL') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.material_others);
              } else if (this.dialog_type === 'OTHER') {
                this.appendCheckboxData(response.record_id, that.dialog_name, that.other_works);
              }
            }
            this.$store.commit("setWaiting", false);
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },

    deleteInputHistory() {
      var that = this;
      let updateUrl = "/work/history/update";

      if (this.dialog_id < 0) {
        if (this.dialog_type === 'SEEDLING') {
          this.deleteCheckboxData(this.dialog_id, that.seedling_others, that.formData.seedling_others);
        } else if (this.dialog_type === 'RAFT') {
          this.deleteCheckboxData(this.dialog_id, that.raft_others, that.formData.raft_others);
        } else if (this.dialog_type === 'SHIP') {
          this.deleteCheckboxData(this.dialog_id, that.ship_others, that.formData.ship_others);
        } else if (this.dialog_type === 'WORKPLACE') {
          this.deleteCheckboxData(this.dialog_id, that.workplace_others, that.formData.workplace_others);
        } else if (this.dialog_type === 'MATERIAL') {
          this.deleteCheckboxData(this.dialog_id, that.material_others, that.formData.material_others);
        } else if (this.dialog_type === 'OTHER') {
          this.deleteCheckboxData(this.dialog_id, that.other_works, that.formData.other_works);
        }
        return;
      }

      let postData = {
        'record_type': 'DELETED',
        'record_id': this.dialog_id,
      }

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then(() => {
            if (this.dialog_type === 'SEEDLING') {
              this.deleteCheckboxData(this.dialog_id, that.seedling_others, that.formData.seedling_others);
            } else if (this.dialog_type === 'RAFT') {
              this.deleteCheckboxData(this.dialog_id, that.raft_others, that.formData.raft_others);
            } else if (this.dialog_type === 'SHIP') {
              this.deleteCheckboxData(this.dialog_id, that.ship_others, that.formData.ship_others);
            } else if (this.dialog_type === 'WORKPLACE') {
              this.deleteCheckboxData(this.dialog_id, that.workplace_others, that.formData.workplace_others);
            } else if (this.dialog_type === 'MATERIAL') {
              this.deleteCheckboxData(this.dialog_id, that.material_others, that.formData.material_others);
            } else if (this.dialog_type === 'OTHER') {
              this.deleteCheckboxData(this.dialog_id, that.other_works, that.formData.other_works);
            }
            this.$store.commit("setWaiting", false);
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },

    register() {
      // 生産情報登録
      let updateUrl = "";
      let postData = null;

      updateUrl = "/work/record/update";
      postData = this.buildRegisterData();

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then(() => {
            this.$store.commit("setWaiting", false);
            this.$router.push("/product");
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },
    cancel() {
      this.$router.push("/product");
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
}

.card-error {
  background-color: #ffdbe2;
}

.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}

.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}

.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}

.big-checkbox {
  transform: scale(1.4);
  transform-origin: 0% 50%;
  font-size: 24px;
  margin-left: 24px;
  margin-right: 24px;
}

.v-text-field >>> input {
  font-size: 24px;
  padding: 0 !important;
}

.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
